/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

//
// The TemplateTree searches templates in the DOM.
//
// *Process*
// 1. build tree
//   var tt = new TemplateTree(rootEl, rootTemplateType);
//
// 2. create views based on template tree
//   tt.initialize(model, callback);
//
// 3. destroy all created views and unregister all event handlers
//   tt.destroy(callback);
//
// *Editor Lifecycle*
//
// Repeat steps 1-3 after each edit
//

// use "mindbreezeRequire" or "require" (webpack/requireJS )
var useMindbreezeRequire = true;
define([
  useMindbreezeRequire ? "mindbreezeRequire" : "require",//mindbreezeRequire or require
  "underscore",
  "client/template-tree/guard",
  "client/schema",
  "component!results",
  "component!clientnotification",
  "mbmustache",
  "jquery",
  "utils/dom",
  ], function(
    require,
    _,
    Guards,
    Schema,
    ResultsTemplate,
    ClientNotificationTemplate,
    Mustache,
    $,
    dom
) {

  function expandTemplateChildren(template, bindings, cb) {
    for (var i = 0; i < template.content.childNodes.length; ++i) {
      var node = template.content.childNodes[i];
      if (node.nodeType == node.TEXT_NODE) {
        var textNode = document.createTextNode(Mustache.render(node.nodeValue, bindings));
        cb(textNode);
      }
      else {
        cb(node.cloneNode(true));
      }
    }
  }
   
  function renderVarsExpandTemplate(node, bindings) {
    var templates = node.querySelectorAll("template[data-expand-vars]");
    if (templates.length > 0) {
      _.each(templates, function(template) {
        var parentNode = template.parentNode;
        var nextSiblingNode = template.nextSibling;
        function appendNode(node) {
          if (nextSiblingNode) {
            parentNode.insertBefore(node, nextSiblingNode);
          }
          else {
            parentNode.appendChild(node);
          }
        }
        expandTemplateChildren(template, bindings, appendNode);
        parentNode.removeChild(template);
      });
    }
    return node;
  }
    
  // nodes are DOM nodes
  // bindings is a mapping from var name to var value
  function NodesAndBindings(nodes, bindings) {
    this.nodes = nodes;
    this.bindings = bindings || {};
  }
    
  _.extend(NodesAndBindings.prototype, {

    eachNodeWithinFrame: function(env, callback) {
      env.pushFrame(this.bindings);
      try {
        _.each(this.nodes, callback);
      } finally {
        // TODO: this is too early: env.popFrame();
      }
    }
  });


  function renderVarsExpandTemplate(node, bindings)
  {
    var templates = node.querySelectorAll("template[data-expand-vars]");
    if (templates.length > 0) {
      _.each(templates, function(template) {
        var parentNode = template.parentNode;
        var nextSiblingNode = template.nextSibling;
        function appendNode(node) {
          if (nextSiblingNode) {
            parentNode.insertBefore(node, nextSiblingNode);
          }
          else {
            parentNode.appendChild(node);
          }
        }            
        for (var i = 0; i < template.content.childNodes.length; ++i) {
          var node = template.content.childNodes[i];
          if (node.nodeType == node.TEXT_NODE) {
        
            function decodeSlashAndCaret(htmlString) {
              return htmlString
                .replace(/&#47;|&#x2F;/g, '/')  // Decode &#47; or &#x2F; to /
                .replace(/&#94;|&#x5E;/g, '^'); // Decode &#94; or &#x5E; to ^
            }

            var decoded = decodeSlashAndCaret(Mustache.render(node.nodeValue, bindings)); 
            var textNode = document.createTextNode(decoded);
            appendNode(textNode);
          }
          else {
            appendNode(node);
          }
        }
      });
    }
    return node;
  }
    
  function AppFragmentRef(refEl, options) {
    this.options = options || {};
    this.importNested = this.options.importNested || false;
    this.refEl = refEl;
    this.slotRefEl = this.refEl.querySelector("[slot]");
    this.nextSiblingNode = this.refEl.nextSibling;
    if (!this.importNested) {
	    this.refEl.style.display = "none";
    }
    if (this.slotRefEl) {
      this.slotRefEl.style.display = "none";
    }
    this.nodes = [];
  }

  _.extend(AppFragmentRef.prototype, {

    _insertInDOM: function(node) {
      if (this.importNested)
      {
        this.refEl.appendChild(node);
      }
      else {
        if (this.nextSiblingNode) {
          this.refEl.parentNode.insertBefore(node, this.nextSiblingNode);
        } else {
          this.refEl.parentNode.appendChild(node);
        }
      }
    },
    
    // returns a list of nodes that are imported
    //   to the dom
    importFragment: function(appFragmentJson) {
      if (this.nodes && this.nodes.length > 0) {
        console.warn("This ref was already resovled.");
        this.remove();
      }

      var bindings = {};
      this.appFragmentJson = appFragmentJson;
      var schema = this.appFragmentJson.schema || {};
      if (!_.isEmpty(schema)) {
        this.schema = new Schema(schema);
        var attributesAsCamelCase = new dom.AttributeModel(this.refEl, "data-").getCamelCase();
        bindings = this.schema.parseAttributes(attributesAsCamelCase, {schemaOnly: true, errorContext: function() { return "importFragment of " + appFragmentJson.type + "." + appFragmentJson.name}});
      }

      
      var styleText = this.options.themeable
          ? this.options.themeable.getStyleTextForModule(appFragmentJson.type, appFragmentJson.name)
          : null;
      
      
      var fragment = document.createElement("div");
      fragment.innerHTML = appFragmentJson.htmlFragment;
      if (styleText) {
        var styleEl = document.createElement("style");
        styleEl.innerHTML = styleText;
        if (fragment.childNodes.length > 0) {
          fragment.insertBefore(styleEl, fragment.childNodes[0]);
        }
        else {
          fragment.appendChild(styleEl);
        }
      }
      if (this.slotRefEl) {
        var slotPlaceHolder = fragment.querySelector("slot");
        if (slotPlaceHolder) {
          var insertBeforeEl = slotPlaceHolder.nextSibling;
          for (var i = 0; i < this.slotRefEl.childNodes.length; ++i) {
            var childNode = this.slotRefEl.childNodes[i];
            var cloned = childNode.cloneNode(true);
            if (insertBeforeEl) {
              slotPlaceHolder.parentNode.insertBefore(cloned, insertBeforeEl);
            }
            else {
              slotPlaceHolder.parentNode.appendChild(cloned);
            }
          }
          slotPlaceHolder.parentNode.removeChild(slotPlaceHolder);
        }
      }
      
      renderVarsExpandTemplate(fragment, bindings);
      this.refEl.setAttribute("data-replaced", "true");
      var nodes = [];
      var beforeNode = this.refEl.nextSibling;                
      while (fragment.childNodes.length > 0) {
        var node = fragment.childNodes[0];
        nodes.push(node);
        this._insertInDOM(node);
      }
      this.nodes = nodes;
      return new NodesAndBindings(nodes, bindings);
    },
    
    remove: function() {
      this.refEl.removeAttribute("data-replaced");
      if (this.nodes) {
        _.each(this.nodes.reverse(), function (node) {
          if (node.parentNode) {
            try {
              node.parentNode.removeChild(node);
            } catch (e) {
              // ignore 
            }
          }
        });
        this.nodes = [];
      }
    }
  });
    
  // initializes tree nodes recursivly
  //
  // 1. loads the component if necessary
  // 2. instantiates templates
  // 3. calls itself for children
  function initializeNode(node, application, callback, settingsConfig) {
    // console.log("initializeNode", node.templateType);
      
    var errors;
    var componentLoadPromise = {
      loadClientComponentAsync: function(name) {
        var module = "component!" + name;        
        return new Promise(function(resolve, reject) {
          require([module], function (Template) {
            resolve(Template);
          });
        });
      }
    }
    var parentLoaderPromise =  componentLoadPromise.loadClientComponentAsync(node.templateType);
    
    componentLoadPromise = application != null && application.extensionManager
      ? application.extensionManager.loadClientComponentAsync(node.templateType, parentLoaderPromise)
      : parentLoaderPromise;

    componentLoadPromise.then(
      function (Template) {
        var callbackCount;
        var callbackHandler;
        // turns the node into a template
        // console.log("creating template " + node.templateType);
        node.template = new Template(node.el, node, application, settingsConfig);
        node.template.childrenPromise.then(function (children) {
          callbackCount = children.length;
          callbackHandler = function () {
            callbackCount--;
            // console.log("callbackCount", callbackCount);
            if (callbackCount === 0) {
              try {
                callback(errors);
              } catch (e) {
                if (console && console.warn) console.warn("Failed to notify template tree initialization.", e.stack, e);
              }
            }
          };
          
          if (node.template.initializationPromise) {
            // additional condition to callback
            callbackCount++;
            node.template.initializationPromise.always(callbackHandler);
          }
          
          if (callbackCount === 0) {
            callback();
          }
          
	        _.forEach(children, function (child) {
            try {
              initializeNode(child, application, callbackHandler, settingsConfig);
            } catch (e) {
              if (!errors) errors = [];
              errors.push(e);
            }
          });
        });
      });
  };

  function eachNodePost(node, cb) {
    _.forEach(node.children, function(child) {
      eachNodePost(child, cb);
    });
    cb(node);
  };


  // context (e.g. extracted from elements between two needs) which should be passed down to the child node
  var ChildNodeContext = function (guard, options) {
    this.guard = guard;
    this.options = options ? _.extend({}, options) : {};
  };

  _.extend(ChildNodeContext.prototype, {
    addGuard: function(newGuard) {
      if (!newGuard) return;

      if (!(newGuard instanceof Guards.Guard)) {
        return;
      }      

      if (this.guard) {
        // already has found a guard -> use case: nested guard expressions
        // not adding nested otherwise guards - since the semantic of an otherwise guard is, that it evaluate to true anyways
        // TODO: this only makes sense if a nested otherwise guard is in the correct order/position (e.g. hat to be the last guard in the scope)
        if (!newGuard.isOtherwiseGuard) {
          this.guard.nestedGuards.push(newGuard);
        }
      } else {
        this.guard = newGuard;
      }
    },

    setReadonly: function() {
      // inherited by future contexts
      this.options.readonly = true;
    },
    
    clone: function() {
      const clonedGuard = this.guard === undefined ? undefined : this.guard.clone();
      return new ChildNodeContext(clonedGuard, this.options);
    }
  });


  var AttributeReader = function (application) {
    this.application = application;

    if (!this.application) {
      this.exprEnvironment = null;
      
      console.warn('TemplateTree constructor is missing the application instance');
      return;
    }

    this.exprEnvironment = application.exprEnvironment;
  }
  _.extend(AttributeReader.prototype, {

    hasAttribute: function (el, name) {
      if (!el || !el.hasAttribute) {
        return false;
      }
      return el.hasAttribute(name) || el.hasAttribute("$" + name);
    },
    
    getAttribute: function (el, name) {
      if (!el.getAttribute) {
	      return null;
      }
      var attValue = el.getAttribute(name);
      if (attValue != null) {
	      return attValue;
      }
      attValue = el.getAttribute("$" + name);
      if (attValue == null) {
        return null;
      }
      // TODO: improve performance, by lazy lookup in render
      return Mustache.render(attValue, this.exprEnvironment ? this.exprEnvironment.getBindings() : {});
    }
  });
    
  var Node = function (tree, el, templateType, parentNode) {
    this.tree = tree;
    this.el = el; /* the DOM element of node */
    this.templateType = templateType; /* the type of the template as specified by data-template or type="text/x-mustache-template" */
    this.parentNode = parentNode;
    // inherit readonly flags from parentNode
    // in case of lateinitalize via search component use node in tree options
    if ((this.parentNode && this.parentNode.readonly) || (this.tree.options.node && this.tree.options.node.readonly)) {
      this.readonly = true;
    }        
    this.children = [];
    this.clonedChildren = []; /* stores references to the cloned/expanded child DOM-Nodes*/
  };

  _.extend(Node.prototype, {
      remove: function () {
        var that = this;

        if (this.parentNode) {
          this.parentNode.children = _.filter(this.parentNode.children, function (child) {
            return child !== that;
          });
          delete this.parentNode;
        }
      },

      firstChildOfType: function (type) {
        return _.find(this.children, function (child) {
          return child.templateType === type;
        });
      },

      append: function () {
        const args = Array.from(arguments);
        if (args.length > 0) {
          for (const arg of args) {
            this.el.appendChild(arg);
          }
          return this.collect();
        }
      },

      collect: function(cb) {
        var that = this;

        // TODO: handle combined callback
        return Promise.allSettled(_.map(this.el.childNodes, function (el) {
          return that.tree.collect(that, el, cb);
        })).then(function () {
	        return that.children;
	      });
      },

      // returns Promise 
      collectAsync: function() {
        var that = this;

        // TODO: handle combined callback
        return Promise.all(_.map(this.el.childNodes, function (el) {
            return that.tree.collectAsync(that, el);
        }));
      },

    
      initializeChildren: function (application, model, callback) {
        var that = this;

        _.forEach(this.children, function (child) {
          initializeNode(child,
            application,
            /* callback */
            function () {
              child.template.createView({
                  application: application,
                  model: model,
                  node: child
              });
              if (callback) {
                try {
                  callback();
                } catch (e) {
                  console.error(e, e.stack);
                }
              }
          }, that.options.settingsConfig);
        });
      },

      destroy: function (callback) {
        eachNodePost(this, function(node) {
            if (node.template && node.template.removeViews) node.template.removeViews();
            node.cleanUpClonedChildren();
        });

        this.cleanUpClonedChildren();

        this.template.remove({
          node: this
        });

        if (callback) {
          callback();
        }
      },
      
      destroyChildren: function (callback) {
        _.forEach(this.children, function (node) {
            eachNodePost(node, function(node) {
              if (node.template && node.template.removeViews) node.template.removeViews();
              node.cleanUpClonedChildren();
            });

            node.cleanUpClonedChildren();

            node.template.remove({
              node: node
            });

        });

        if (callback) {
          callback();
        }
      },

      cleanUpClonedChildren: function () {
        if (!this.el) return; 

        var that = this;

        _.forEach(this.clonedChildren, function(clonedChild) {
          try {
            that.el.removeChild(clonedChild);
          } catch (ignored) {
              /* NOOP */
          }
        });

        // clear references to allow for gc
        this.clonedChildren = [];
      },

      withContext: function (context) {
        // propagates the readonly from the context (set when importing fragments)
        if (context.options && context.options.readonly) {
          this.readonly = true;
        }
        this.guard = context.guard;
      },
  });

  // Builds the tree, starting at roolEl using the given template type for the root node
  var TemplateTree = function (rootEl, rootTemplateType, templateString, options) {
    this.init.apply(this, arguments);
  };

  _.extend(TemplateTree.prototype,  {

    init: function (rootEl, rootTemplateType, templateString, options) {
      rootEl = rootEl || document.body;
      options = options || {};
      this.options = options;

      if (_.isArray(rootEl)) {
        this.rootEls = rootEl;
      } else {
        if (templateString) {
          rootEl.innerHTML = templateString;
        }
        this.rootEls = [rootEl];
      }

      this.appFragmentJson = options.appFragmentJson;
      this.appFragmentContainerEl = options.appFragmentContainerEl;
      
      this.rootTemplateType = rootTemplateType;
      this.application = options.application;
      this.attributeReader = new AttributeReader(this.application);
      var that = this;
      this._appFragmentRefs = [];
      this._templateTypePredicates = [];
      this.application && this.application.trigger("templatetree-create", this, this.application);
      if (!this.application) {
        console.warn("Tamplate Tree: application object is missing!")
      }
      
      this.rootNodePromise = this.build();
      this.rootNodePromise.then(function (rootNode) {
        that.rootNode = rootNode
      });
    },

    registerTemplateType: function(predicate) {
      this._templateTypePredicates.push(predicate);
    },

    getTemplateInfoIfMatches: function(el) {
      for (const templateTypePredicate of this._templateTypePredicates) {
        const result = templateTypePredicate(el);
        if (result) {
          return result;
        }
      }
    },
    
    // determines if an element is a template
    matches: function (el) {
      try {
        if (el.nodeType == el.TEXT_NODE) {
          return false;
        }
        var templateName = el.getAttribute && el.getAttribute("data-template");
        if (templateName == "360") {
          // ignore this template as it was used previously to mark app modules
          return false;
        }
        var result = !!(templateName || el.getAttribute("type") === "text/x-mustache-template");
        if (!result) {
          var templateInfo = this.getTemplateInfoIfMatches(el);
          return templateInfo != null;
        }
        return result;
      } catch (e) {
        return false;
      }
    },

    isAppFragmentRef: function (el) {
      try {
        return this.attributeReader.hasAttribute(el, "data-app-fragment-ref-type")
	        || this.attributeReader.hasAttribute(el, "data-app-fragment-ref-name")
	        || this.attributeReader.hasAttribute(el, "data-app-fragment-ref-names");
      } catch (e) {
        return false;
      }
    },

    getType: function (el) {
      try {
        var templateAttribute = el.getAttribute("data-template");
        if (templateAttribute != null) {
          return templateAttribute;
        }
        var templateInfo = this.getTemplateInfoIfMatches(el);
        if (templateInfo) {
          return templateInfo.templateType;
        }
        return "mustache";
      } catch (e) {
        return "mustache";
      }
    },

    getAttribute: function (element, attributeName) {
      if (element && element.getAttribute) {
        return element.getAttribute(attributeName);
      }

      return undefined;
    },

    hasAttribute: function (element, attributeName) {
      return this.getAttribute(element, attributeName) != undefined;
    },

    // Returns a Promise<DOMNode[]>
    tryResolveAppFragmentTemplateReferencesAsync: function(parentNode, el) {
      if (!this.isAppFragmentRef(el)) {
        return Promise.resolve([el]);
      }
      
      if (!this.application) {
        console.warn('TemplateTree constructor is missing the application instance');
        return;
      }

      // TODO build an internal wrapper for the app fragment store.
      const appFragmentStoreV1 = this.application.clientExtensions && this.application.clientExtensions.getReadonlyAppFragmentStoreV1();

      if (appFragmentStoreV1 == null) {
        // currently no builtin API
        return new Promise(function(resolve, reject) { reject(new Error("AppFragmentStore unavailable")); });
      }

      // TODO: here we can use settings from the application.
      var refType = this.attributeReader.getAttribute(el, "data-app-fragment-ref-type"),
          refNames = this.attributeReader.getAttribute(el, "data-app-fragment-ref-names");
      if (refNames == null) {
        refNames = this.attributeReader.getAttribute(el, "data-app-fragment-ref-name");
        if (refNames != null) {
          refNames = [refNames];
        }
      } else {
        refNames = refNames.split(/\s+/);
      }
   
      if (!refNames) {
        // check if we have settings.
        // appFragmentRefNames[refType]
        // get also the settings.
      }
      var that = this;
      var promise = appFragmentStoreV1.findFirstByTypeAndNames(refType, refNames, {application: this.application});
      return promise.then(function (appFragmentJson) {
        var appFragmentRef = new AppFragmentRef(el, {importNested: true, themeable: that.application.themeable});
        that._appFragmentRefs.push(appFragmentRef);
        return appFragmentRef.importFragment(appFragmentJson);
      });
    },

    // returns Promise<DOMNode[] | NodesAndBinding>
    importAppFragment: function (parentEl, appFragmentJson, options) {
      options = options || {};
      var themeable = this.application.themeable;
      // TODO differntiate between real AppFragmentRef and AppFragmentPlacement
      var appFragmentRef = new AppFragmentRef(parentEl, {importNested: true, themeable: themeable});
      if (!options.disableAutoRemove) {
        this._appFragmentRefs.push(appFragmentRef);
      }
      return new Promise(function(resolve, reject) {
        resolve(appFragmentRef.importFragment(appFragmentJson));
      });
    },
    
    tryExpandForEach: function (parentNode, el, exprEnvironment) {
      var that = this;

      var forEachExpression = this.getAttribute(el, "data-for-each-expr");

      if (!forEachExpression) {
        return [el];
      }

      el.style.display = "none";

      var dataValueAsName = this.getAttribute(el, "data-value-as") || "value"; // default name is "value"
      var dataKeyAsName = this.getAttribute(el, "data-key-as") || "";
      var expandAttrNamePattern = this.getAttribute(el, "data-expand-attr-name-pattern") || /^[$](.*)$/;
      
      var insertBeforeNode = el.nextSibling; 
      var parentElement = el.parentNode;

      var result = [];

      function renderAttributeValue(templateText, value)  {
        return Mustache.render(templateText, value);
      }        
      
      function renderAttributeValues(node, value) {
        for (var i = 0; i < node.attributes.length; i++) {
          var attribute = node.attributes[i];
          var attributeName = attribute.name;
          
          var matchResult = attributeName.match(expandAttrNamePattern);
          
          if (matchResult != null) {
            var templateText = attribute.value;

            var renderedAttributeName = matchResult[1];
            var renderedValue = renderAttributeValue(templateText, value);

            // swap unrendered with rendered attribute name & value
            node.removeAttribute(attributeName);
            node.setAttribute(renderedAttributeName, renderedValue);
          }
        }
      }
      
      function insertAfterForEachAndRecord(parentNode,node) {
        if (insertBeforeNode == null) {
          parentElement.appendChild(node);
        } else {
          parentElement.insertBefore(node, insertBeforeNode);
        }

        parentNode.clonedChildren.push(node);
        result.push(node);
      }
      
      function cloneChildNodesAndExpandPatternsRec(dest, nodes, key, value, insertFun, enteredDifferentExpansionScope) {
        if (!nodes) return;

        var wrappedValue = {};
        wrappedValue[dataKeyAsName] = key;
        wrappedValue[dataValueAsName] = value;

        function appendChild(cloned) {
          if (insertFun != null) {
            insertFun(dest, cloned);
          }
          else {            
            dest.appendChild(cloned);
          }
        }

        for (var i = 0; i < nodes.length; i++) {
          var node =  nodes[i];
          var cloned = node.cloneNode(false);
          
          // expand attributes if no nested for-each was reached yet and if there are any
          if (!enteredDifferentExpansionScope && cloned instanceof Element && cloned.hasAttributes()) {
            renderAttributeValues(cloned, wrappedValue);
          }

          if (cloned.nodeName.toUpperCase() == "SCRIPT") {
             // could be that this also contains template refs.
            var fragment = document.createElement("div");
            fragment.innerHTML = node.text;

            // This expands the variables.
            renderVarsExpandTemplate(fragment, wrappedValue);
            var pattern = /\s(\$[\w-]+)="([^"]*)"/g;
            var text  = fragment.innerHTML;
            var expandedText = "";
            var match;
            var lastIndex = 0;

            function safe(text) {
              var map = {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'};
              return text.replace(/[&<>"']/g, function(c) { return map[c]});
            }
            
            while ((match = pattern.exec(text)) != null) {
              expandedText += text.substring(lastIndex, match.index);
              expandedText += " "
              expandedText += match[1].substring(1);
              expandedText += '="'
              expandedText += safe(Mustache.render(match[2], wrappedValue));
              expandedText += '"';
              lastIndex = match.index + match[0].length;
            }
            expandedText += text.substring(lastIndex);
            cloned.text = expandedText;
            appendChild(cloned);
          } else if (node.nodeType == node.ELEMENT_NODE && cloned.nodeName.toUpperCase() ==  "TEMPLATE" && cloned.hasAttribute("data-expand-vars"))  {
            expandTemplateChildren(node, wrappedValue, appendChild);
          } else {
            if (node.childNodes.length > 0) {
              
              cloneChildNodesAndExpandPatternsRec(
                cloned, 
                node.childNodes,
                key,
                value,
                null,
                enteredDifferentExpansionScope || that.hasAttribute(cloned, "data-for-each-expr") // stop expanding after reaching another for-each
              );
            }
            appendChild(cloned);
          }   
        }
      }
      
      if (!this.application) {
        console.warn('TemplateTree constructor is missing the application instance');
        return;
      }

      var evaluationFunction = exprEnvironment ?  exprEnvironment.createExprFunction(forEachExpression) : null;
      var values = []
      try {
        values = evaluationFunction ? exprEnvironment.applyExprFunction(evaluationFunction) : [];
      } catch (e) {
        if (console && console.log) {
          console.log("Failed to eval expression", e);
        }
      }
      _.forEach(values, function (value, key) {
          // todo copy children.
          var childrenElements = el.content ? el.content.childNodes : el.childNodes;
          cloneChildNodesAndExpandPatternsRec(parentNode, childrenElements , key, value, insertAfterForEachAndRecord);
      });
      return result;     
    },

    importAppFragmentAndCollect: function (parentNode, el, appFragmentJson, callback, childNodeContext, exprEnvironment) {
      var exprEnvironment = exprEnvironment || (this.application ?  this.application.exprEnvironment : null);
      var that = this;

      var currentChildContext = childNodeContext;
      if (currentChildContext) {
        currentChildContext = childNodeContext.clone();
      }
      else {
        currentChildContext = new ChildNodeContext();
      }

      //
      // This only works on the newly created childNodes
      // - it does not also collect on the  
      return this.importAppFragment(el, appFragmentJson).then(function (childNodes, rejectReason) {
        // TODO childNodes are created and should be cleaned up again.
        var childNodeContext = currentChildContext;
        if (childNodes) {
          if (childNodes instanceof NodesAndBindings) {
            childNodeContext = childNodeContext ? childNodeContext.clone() : new ChildNodeContext();
            childNodeContext.setReadonly();
            var nodesAndBindings = childNodes;
            if (exprEnvironment) {
              exprEnvironment = exprEnvironment.pushFrameInClonedEnv(nodesAndBindings.bindings);
            }
            childNodes = nodesAndBindings.nodes;
          }
          _.each(childNodes, function(childEl) {
            that.collect(parentNode, childEl, callback, childNodeContext, exprEnvironment);
          });
        } else if (rejectReason) {
          console.warn("[templatetree] Failed to import app-fragment, reason", rejectReason);
        }
      }).catch(function (error) {
        console.warn("[templatetree] Failed to import app-fragment, error", error);
      });
    },

    importAppFragmentsAndCollectWithChildNodes: function (parentNode, el, appFragmentJsonLists, callback, childNodeContext, exprEnvironment) {
      var exprEnvironment = exprEnvironment || (this.application ?  this.application.exprEnvironment : null);
      var that = this;

      var currentChildContext = childNodeContext;
      if (currentChildContext) {
        currentChildContext = childNodeContext.clone();
      }
      else {
        currentChildContext = new ChildNodeContext();
      }

      var childNodes = Array.from(el.childNodes);
      var promises = _.map(_.flatten(appFragmentJsonLists, 1), function(appFragmentJson) {
        return that.importAppFragment(el, appFragmentJson);
      });
      if (childNodes.length > 0) {
        promises = [Promise.resolve(childNodes)].concat(promises);        
      }  
      
      return Promise.all(promises).then(function (childNodeList, rejectReason) {
        that.collect(parentNode, el, callback, currentChildContext, exprEnvironment);
      })
    },

    
    // walks down the DOM tree starting at el and adds template nodes as found
    // also should return a Promise then?
    collect: function (parentNode, el, callback, childNodeContext, exprEnvironment) {
      try {
        if (el && el.getAttribute && el.getAttribute("data-mb-exclude") === "true") {
          return Promise.resolve([]);
        }
      } catch (e) { }

      var currentChildContext = childNodeContext;
      if (currentChildContext) {
        currentChildContext = childNodeContext.clone();
      }
      else {
        currentChildContext = new ChildNodeContext();
      }

      // TODO: introduce an environment per template tree constructiont that inherits
      //       attributes from the application expr environment, this would be an additional
      //       parameter in the collect function
      var exprEnvironment = exprEnvironment || (this.application ?  this.application.exprEnvironment : null);
      
      if (this.matches(el)) {
        // stop if this node is already part of some hiearchy
        if (_.indexOf(this.processedEls, el) != -1) {
	        return Promise.resolve([]);
        }

        // resolve vars
        function renderAttributeValue(templateText, value)  {
          return Mustache.render(templateText, value);
        }        

        var expandAttrNamePattern = /^[$](.*)$/;
        var bindings = null;
        
        function expandAttributeVars(node) {
          for (var i = 0; i < node.attributes.length; i++) {
            var attribute = node.attributes[i];
            var attributeName = attribute.name;            
            var matchResult = attributeName.match(expandAttrNamePattern);
            
            if (matchResult != null) {
              var templateText = attribute.value;
              if (bindings == null) {
                bindings = exprEnvironment ? exprEnvironment.getBindings() : {};
              }
              var renderedAttributeName = matchResult[1];
              // @todo experimental
              // loop over bindings, if attr is object, set attr = JSON.stringidy(attr)
              var renderedValue = Mustache.render(templateText, bindings);
              
              // swap unrendered with rendered attribute name & value
              node.removeAttribute(attributeName);
              node.setAttribute(renderedAttributeName, renderedValue);
            }
          }
        }

        expandAttributeVars(el);
        var childNode = new Node(this, el, this.getType(el), parentNode);
        this.processedEls.push(el);

        if (currentChildContext) {
          childNode.withContext(currentChildContext);
          // unset after consumption - will be recreated when (/if) needed
          currentChildContext = undefined; // reset  
        }

        parentNode.children.push(childNode);
        
        if (callback) {
          callback(childNode);
        }

        parentNode = childNode;
      } else {
        if (currentChildContext) {
          var extractedGuard = this.checkForAndExtractGuard(el);
          if (extractedGuard) currentChildContext.addGuard(extractedGuard);
        }
      }

      // FIXME: we also stop at data-template search as this
      //        creates a new TemplateTree, this currently cannot
      //        be done generically as this would imply that we
      //        defer the collect until we have resolved components
      if (el.getAttribute && el.getAttribute("data-template") == "search") {
        el.style.display = "none";
        return Promise.resolve([]);
      }
      
      var that = this;
      // create a copy of child nodes, since the NodeList may get modified during expansion (insertion of clones)
      var childNodes = Array.prototype.slice.call(el.childNodes);

      // TODO: this should be done only once and not removed again.
      var appFragmentJsonList = el.appFragmentJsonList ? [].concat(el.appFragmentJsonList) :  [];
      var childNodesPromises = _.map(appFragmentJsonList, function (appFragmentJson) {
        if (that.appFragmentJson == appFragmentJson) {
          return that.importAppFragment(el, appFragmentJson, {disableAutoRemove: true}).then(function (result) {
            // if this is thte currently loaded appFragmentJson
            that.importedAppFragmentJson = that.appFragmentJson;
            that.appFragmentJson = null;
            return result;
          });
        }
        else {
          return that.importAppFragment(el, appFragmentJson);
        }
      });

      _.forEach(childNodes, function (childEl) {        
        _.forEach(that.tryExpandForEach(parentNode, childEl, exprEnvironment), function (childEl) {
          // Returns the newly resolved and inserted nodes to be used for collection.
          childNodesPromises.push(that.tryResolveAppFragmentTemplateReferencesAsync(parentNode, childEl));
        });
      });

      childNodesPromises = _.map(childNodesPromises, function (childNodesPromise) {
        return childNodesPromise.then(function (childNodes, rejectReason) {
          // TODO childNodes are created and should be cleaned up again.
          var childContext = currentChildContext;
          if (childNodes) {
            if (childNodes instanceof NodesAndBindings) {
              childContext = childContext ? childContext.clone() : new ChildNodeContext();
              childContext.setReadonly();              
              var nodesAndBindings = childNodes;
              if (exprEnvironment) {
                exprEnvironment = exprEnvironment.pushFrameInClonedEnv(nodesAndBindings.bindings);
              }
              childNodes = nodesAndBindings.nodes;
            }
            return Promise.allSettled(_.map(childNodes, function(childEl) {
              return that.collect(parentNode, childEl, callback, childContext, exprEnvironment);
            }));
            
          } else if (rejectReason) {
            console.warn("[templatetree] Failed to resolve app-fragment, reason", rejectReason);
          }
        }).catch(function (error) {
          console.warn("[templatetree] Failed to resolve app-fragment, error", error);
        });
      });
    
      return Promise.allSettled(childNodesPromises);
    },

    checkForAndExtractGuard: function (element) {
      var that = this;

      var guardExpression = this.getAttribute(element, "data-guard-expr");

      function getRequiredGuardProperties (element) {
        var rawRequiredProperties = that.getAttribute(element, "data-guard-requires-properties");
  
        if (rawRequiredProperties) {
          return rawRequiredProperties.split(','); // TODO check if ',' is a good seperation character
        }
  
        return [];
      };

      if (guardExpression != undefined) {
        var guard = new Guards.Guard(guardExpression);

        _.each(
          getRequiredGuardProperties(element), 
          function(requiredProperty) { guard.addRequiredProperty(requiredProperty); }
        );

        return guard;
      }

      if (this.hasAttribute(element, "data-guard-otherwise")) {
        return new Guards.OtherwiseGuard();
      }
    },

    build: function () {
      var application = this.application;
      var extensionManager = application != null && application.extensionManager && application.extensionManager
      var appFragmentsForPreloading = extensionManager && extensionManager.preloadAppFragments({application: application});
      
      ResultsTemplate.beforeTemplateTreeInitialization(this.rootEls, this.application);
      ClientNotificationTemplate.beforeTemplateTreeInitialization(this.rootEls, this.application);

      var that = this;
      this.processedEls = [];

      var appFragmentParentEl = null;
      if (this.appFragmentContainerEl != null) {
        appFragmentParentEl = this.appFragmentContainerEl;
      }

      var appFragmentJson = this.appFragmentJson;
      // if we have an appFragmetnContainerEl that is not the rootEl.
      // TOOD: also check that is not whithin the rootEl.
      if (appFragmentParentEl != null) {
        if (appFragmentJson) {
          appFragmentParentEl.appFragmentJsonList = [appFragmentJson];
          appFragmentJson = null;
        }
        else {
          appFragmentParentEl.appFragmentJsonList = [];
        }
      }

      if (this.rootEls.length == 1 && (appFragmentsForPreloading.length > 0|| appFragmentJson)) {
        var promises = [];
        if (appFragmentJson) {
          promises.push(Promise.resolve([appFragmentJson]));
        }
        if (appFragmentsForPreloading) {
          promises = promises.concat(appFragmentsForPreloading);
        }
        var rootNode = new Node(that, that.rootEls[0], that.rootTemplateType);
        return Promise.all(promises).then(function(appFragmentJsonLists) {
          that.importAppFragmentsAndCollectWithChildNodes(rootNode, that.rootEls[0], appFragmentJsonLists)
            .then(function(resolved) {
              return rootNode;
            });
        }).then(function (values) {
          return rootNode;
        });
      } else {
        var rootNode = new Node(that, this.rootEls.length === 1 ? this.rootEls[0] : null, that.rootTemplateType);
        return Promise.allSettled(_.map(this.rootEls, function (rootEl) {
          return that.collect(rootNode, rootEl);
        })).then(function (values) {
          return rootNode;
        });
      }
    },

    // load templates, initialize templates and create view
    // of root template. The createView functions of the templates
    // must take care of creating the sub views as necessary
    initialize: function (application, model, callback) {
      var that = this;
      return new Promise(function (resolve, reject) {
        that.rootNodePromise.then(function (rootNode) {
          initializeNode(
            rootNode,
            application,
            /* callback */
            function (errors) {
              var rootView = rootNode.template.createView({
                application: application,
                model: model,
                node: rootNode
			        });

              resolve(rootView);
              
			        if (callback) {
                try {
                  callback();
                } catch (e) {
                  console.error(e, e.stack);
                }
			        }
            },
            that.options.settingsConfig
          )
        })
        
      });
    },

    reload: function(application, model, callback, destroyedCallback) {
      var that = this;

      this.destroy(function () {
        if (destroyedCallback) destroyedCallback();
        // if (application.options.appFragmentJson && application.options.appFragmentJson != that.importedAppFragmentJson) {
          /// TODO: what if we already loaded this one?
        //  that.appFragmentJson = application.options.appFragmentJson;
        //}
        that.rootNodePromise = that.build();
        that.rootNodePromise.then(function (rootNode) {
          that.rootNode = rootNode;
          that.initialize(application, model, callback);
        });
      });
    },


    reset: function(htmlFragment, resetCallback) {
      if (this.appFragmentContainerEl) {
        var that = this;
        this.destroy(function () {
          that.appFragmentContainerEl.innerHTML = htmlFragment;
          if (resetCallback) {
            resetCallback();
          }
        });
      }
    },

    getAppFragmentContainerEl: function() {
      if (this.appFragmentContainerEl) {
        return this.appFragmentContainerEl;
      }
      return null;
    },
    
    // calls remove on root template, which is responsible
    // for removing subviews as well
    destroy: function (callback) {
      var that = this;
      return new Promise((resolve, reject) => {
      this.rootNodePromise.then(function(rootNode) {
        ResultsTemplate.beforeTemplateTreeDestroy(that.rootEls);
        eachNodePost(that.rootNode, function(node) {
          if (node.template && node.template.removeViews) {
              node.template.removeViews();
          }

          node.cleanUpClonedChildren();
        });

        if (that.rootNode.template && that.rootNode.template.remove) {
          try {
            that.rootNode.template.remove({
              node: that.rootNode
            });
          }
          catch (e) {
            console.warn("cloud not finish remove! ", e.message)
          }
        }

        if (that._appFragmentRefs) {
          _.each(that._appFragmentRefs, function (appFragmentRef) {
            appFragmentRef.remove();
          });
          that._appFragmentRefs = [];               
        }
        
        
        if (callback) {
          callback();
        }
        resolve();
      });
      })
    },

    getTemplateByEl: function (el) {
      var template;
      eachNodePost(this.rootNode, function (node) {
        if (!template) {
          if (node.el === el) {
            template = node.template;
          }
        }
      });

      return template;
    },

    getEditableByEl: function (el) {
      var template;
      eachNodePost(this.rootNode, function (node) {
        if (!template) {
          if (node.el === el) {
            template = node.template;
          }
        }
      });

      return template;
    },

    
    queryTemplateByType: function (templateType) {
      var template;
      eachNodePost(this.rootNode, function (node) {
        if (!template) {
          if (node.templateType === templateType) {
            template = node.template;
          }
        }
      });

      return template;
    },

    
    getTemplateById: function (id) {
      if (!id) return;

      return this.getTemplateByEl(document.getElementById(id));
    }
  });

  return TemplateTree;
});
